module.exports = __webpack_public_path__ + "static/media/success.fc998f41.gif";